import type { ColumnSchema } from '../../types/column.types';
import { IMail } from "../../types/mail.types";
import { DateMailColumn } from "./email.renderer";

export const defaultEmailColumns: ColumnSchema<IMail> = {
  uuid: 'defaultEmailColumns',
  schema: {
    createdAt: {
      dataIndex: 'created_at',
      title: 'Date',
      sorter: () => -1,
      width: 250,
      render: DateMailColumn
    },
    subject: {
      dataIndex: 'subject',
      title: 'Subject',
    },
    template: {
      dataIndex: 'template',
      title: 'Template',
    },
    recipients: {
      dataIndex: 'recipients',
      title: 'Recipients',
    },
    sender: {
      dataIndex: 'sender',
      title: 'Sender',
    },
  },
};
